import { getNextStaticProps } from "@faustjs/next";
import is404Cpt from "inc/is404Cpt";
import { client, Job as JobType, JobIdType } from "client";
import { useMenu, useGeneralOptionsSettings } from "hooks";
import Layout from "layouts/main";
import { CEOLink, ApplyNowBanner, Block, BrandColorsDivider } from "components";

export interface JobProps {
  job: JobType | JobType["preview"]["node"] | null | undefined;
}

export function JobComponent({ job }: JobProps) {
  const options = useGeneralOptionsSettings();
  const ceoLink = options?.generalSettings?.ceoLink;
  const headerLinks = useMenu("PRIMARY");
  const footerLinks = useMenu("FOOTER");
  const jobTitle = job.title();
  const jobLink = job?.jobACF?.link;
  const { blocks } = job;

  return (
    <Layout page={job} headerLinks={headerLinks} footerLinks={footerLinks}>
      <ApplyNowBanner jobTitle={jobTitle} jobLink={jobLink} />
      <section className="section-container w-full flex flex-col justify-start items-center mx-auto">
        <div className="content-container w-full px-6 md:px-16 lg:px-20 xl:px-0">
          <div className="m-auto blog-container blog-content">
            <h1 className="text-5xl">{jobTitle}</h1>
            {blocks.map((block, index) => {
              return <Block key={index} block={block} data={job}></Block>;
            })}
          </div>
        </div>
        <BrandColorsDivider className="mt-36" />
      </section>
      <CEOLink
        className="h-[70px] w-[271px] fixed bottom-5 right-5 z-50"
        link={ceoLink}
      />
    </Layout>
  );
}

export default function Job({ id }) {
  const { useQuery } = client;
  const job = useQuery().job({
    id,
    idType: JobIdType.SLUG,
  });

  return <JobComponent job={job} />;
}

export async function getStaticProps(context) {
  const slug = context?.params?.slug;

  return getNextStaticProps(context, {
    Page: Job,
    client,
    props: {
      id: slug,
    },
    notFound: await is404Cpt(slug, "job"),
  });
}

export function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}
